// @ts-nocheck
import { Slash } from "@insite/mobius/Breadcrumbs";
import getColor from "@insite/mobius/utilities/getColor";
import { linkStyles } from "@store/Themes/common/mixins/link"; // Store Custom Code
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { siteWidthStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

const breadcrumbs: Styleguide["breadcrumbs"] = {
    defaultProps: {
        typographyProps: {
            color: "inherit",
            size: "inherit",
        },
        css: css`
            /* Store Custom Code - Remove siteWidthStyles, padding */
            flex-wrap: wrap;
            color: ${getColor("primary")}; /* Store Custom Code - change color to primary */

            ${({ theme }) => `
                font-size: ${theme.design.typography.size.smaller}; /* Store Custom Code - change size to smaller */
            `}

            ${Slash} {
                margin: 0 ${pxToRem(8)};
            }

            a {
                ${linkStyles("inherit", "text.link", false, true)}/* Store Custom Code - change linkAltHover */
            }

            [aria-current="page"] {
                /* Store Custom Code - Remove color, change weight to medium */
                font-weight: ${x => x.theme.design.typography.weight.medium};
            }
        `,
    },
};

export default breadcrumbs;
